import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';


// 夜職タイプ診断の全16タイプイラスト
const yoruShokuImages = [
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/1f7273f2-a282-4994-bd3d-d401b4777fd5_1.png?v=59b06b74b6490b3c1b285a25fa828478',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/ecb345a2-fcd3-4542-8194-3725e0c3c5aa_2.png?v=b6259d97b97a31c1d9ad694d8037a7c6',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/86183747-a6fd-4250-9c28-c8990cb9ceff_7.png?v=8bc30aa614dc9324f381b507f7bac9b7',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/432e342c-c537-43b8-bcf0-bddd3c8f952b_unnamed.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/c44845f2-ad84-4309-8a3e-bddf22e20259_14.png?v=5a79ebdfb9e19e2071bc4f609d0db9ca',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/a9fdf9ce-eb0a-4e39-85a9-2929520d6fcb_8.png?v=2be8baf89313be638527556db79656db',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/b42c9c9a-7762-47ff-a190-aa4c3bc380dc_4.png?v=55a7090179fe8a9fce2f4df11b0a9173',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/5bd4b8c1-22da-4ce3-b473-60474733d9fc_3.png?v=729a67809058e51a5973ca23b5d263c4',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/327497d9-8b59-463b-aeb1-fb92842fe201_5.png?v=c39125f2ab59913380284617fb6ae435',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/4a6a5435-6c08-4262-ac79-928dbd2ce619_16.png?v=289856bdf4906e240db168580580bace',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/f24242a4-6bf7-46a6-a924-fab4057b4e1c_11.png?v=b5bb68ede2cd2dc66dda02f93963ec4c',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/2798e4ad-d550-4299-a298-d19e17cadff9_12.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/952993e3-da33-4248-9d70-9a102e6cd990_6.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/3c100541-8ca3-4b1b-92a8-6a6b525e8c7b_10.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/63fcf0e1-ba03-4987-84a8-876ff5448abd_9.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/d61fed14-13be-4462-94e2-2b220622b76a_15.png',
];

// 地雷タイプ診断の全16タイプイラスト
const jiraiImages = [
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/ebd5d14a-4666-4388-b550-72e407e313eb_DEOQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/89f056c1-1fcc-431e-bc4b-d7a4fafcff98_DLSQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/b9555a27-ab89-44d9-90d5-4e6499c076c0_DEOB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/f193e863-2801-42a6-8301-ad4a19f0483c_DLOB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/fc80d4cf-b8a4-4187-a4d0-554638a09c4f_DLSB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/22cc7a6d-d239-444f-aec6-78eb7ef28867_DESQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/dc52ea1f-4ff9-48dc-abf0-fad38dd21b1f_DLOQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/b33d14c5-9d8c-4dfa-86f7-324956ee1d43_DESB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/96a387e5-3d56-4ec3-a844-21c3445c09ef_ALSB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/56cbe354-f16f-4856-a44e-27821f3eddae_AEOB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/2b05416a-ce0f-4c1e-868e-73fa058e0479_AEOQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/d54a214e-a0da-4b8f-ad34-8e8e46f6b6b9_ALOB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/1db4fb0b-cd84-4e7f-99fd-cdff46eb7c10_ALOQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/3c03dc49-3f87-4368-9ca3-fdd9ebd8fd4f_AESB.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/ad2f3ea1-bc87-4884-a07e-ebd4b203ad07_ALSQ.png',
  'https://storage.readdy-site.link/project_files/2c28dadf-5e81-4f61-8d94-6035bbe4ad32/be00644f-3d52-48b7-ac08-87add93c4eb4_AESQ.png',
];

interface SlideshowImageProps {
  images: string[];
  interval?: number;
  accentColor: string;
  bgColor: string;
}

const SlideshowImage = ({ images, interval = 2000, accentColor, bgColor }: SlideshowImageProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [images.length, interval]);

  return (
    <div
      className="w-full relative overflow-hidden"
      style={{ height: '180px', background: bgColor }}
    >
      {/* 全画像を重ねて opacity で制御 */}
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt="診断タイプイラスト"
          className="absolute inset-0 w-full h-full object-cover object-top"
          style={{
            opacity: i === currentIndex ? 1 : 0,
            transition: 'opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
            willChange: 'opacity',
          }}
          loading="lazy"
          decoding="async"
        />
      ))}
      {/* グラデーションオーバーレイ */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `linear-gradient(to bottom, transparent 40%, ${accentColor}18 100%)`,
          zIndex: 10,
        }}
      />
      {/* ラインインジケーター */}
      <div
        className="absolute bottom-2 left-3 right-3 flex justify-center gap-[3px] pointer-events-none"
        style={{ zIndex: 11 }}
      >
        {images.map((_, i) => (
          <div
            key={i}
            className="flex-1 rounded-full"
            style={{
              height: '2px',
              background: i === currentIndex ? accentColor : `${accentColor}40`,
              transition: 'background 0.6s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
};

interface DiagnosisItem {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  typeCount: string;
  duration: string;
  images: string[];
  accentColor: string;
  bgColor: string;
  path: string;
  available: boolean;
}

const diagnoses: DiagnosisItem[] = [
  {
    id: 'yoru-shoku',
    title: '夜職タイプ診断',
    subtitle: 'NIGHT WORK TYPE',
    description: 'キャバ嬢・ホスト・夜職従事者のスタイルを16タイプで分析。あなたの夜職キャラを丸裸にする。',
    typeCount: '16タイプ',
    duration: '約3分',
    images: yoruShokuImages,
    accentColor: '#7c3aed',
    bgColor: 'rgba(167,139,250,0.08)',
    path: '/quiz',
    available: true,
  },
  {
    id: 'jirai',
    title: '地雷タイプ診断',
    subtitle: 'JIRAI TYPE',
    description: '自分の中に潜む「地雷」を発見。あなたはどんな地雷タイプ？',
    typeCount: '16タイプ',
    duration: '約2分',
    images: jiraiImages,
    accentColor: '#e879a0',
    bgColor: 'rgba(232,121,160,0.08)',
    path: '/jirai-quiz',
    available: true,
  },
];

const DiagnosisCard = ({ item }: { item: DiagnosisItem }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (item.available) {
      navigate(item.path);
    }
  };

  return (
    <div
      className="relative rounded-2xl overflow-hidden flex flex-col transition-all duration-300"
      style={{
        background: '#fff',
        border: `1.5px solid ${item.accentColor}25`,
        opacity: item.available ? 1 : 0.85,
      }}
    >
      {/* Coming Soon バッジ */}
      {!item.available && (
        <div
          className="absolute top-3 right-3 z-20 px-3 py-1 rounded-full text-[10px] font-bold tracking-wider"
          style={{
            background: item.accentColor,
            color: '#fff',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
          }}
        >
          COMING SOON
        </div>
      )}

      {/* スライドショー画像エリア */}
      <SlideshowImage
        images={item.images}
        accentColor={item.accentColor}
        bgColor={item.bgColor}
        interval={2000}
      />

      {/* コンテンツエリア */}
      <div className="flex flex-col flex-1 p-5">
        {/* サブタイトル */}
        <p
          className="text-[9px] tracking-[0.4em] font-medium mb-1.5"
          style={{ color: item.accentColor, fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          {item.subtitle}
        </p>

        {/* タイトル */}
        <h3
          className="text-[#1a1a2e] font-bold text-lg leading-tight mb-2"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          {item.title}
        </h3>

        {/* 説明文 */}
        <p
          className="text-[#6b7280] text-xs leading-relaxed mb-4 flex-1"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          {item.description}
        </p>

        {/* メタ情報 */}
        <div className="flex items-center gap-3 mb-4">
          <div
            className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-medium"
            style={{
              background: `${item.accentColor}12`,
              color: item.accentColor,
              fontFamily: "'M PLUS Rounded 1c', sans-serif",
            }}
          >
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-layout-grid-line text-[10px]" />
            </div>
            {item.typeCount}
          </div>
          <div
            className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-medium"
            style={{
              background: `${item.accentColor}12`,
              color: item.accentColor,
              fontFamily: "'M PLUS Rounded 1c', sans-serif",
            }}
          >
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-time-line text-[10px]" />
            </div>
            {item.duration}
          </div>
        </div>

        {/* ボタン */}
        {item.available ? (
          <button
            onClick={handleClick}
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-sm cursor-pointer transition-all duration-300 hover:scale-[1.02] whitespace-nowrap"
            style={{
              background: `linear-gradient(135deg, ${item.accentColor} 0%, ${item.accentColor}cc 100%)`,
              color: '#fff',
              fontFamily: "'M PLUS Rounded 1c', sans-serif",
              minHeight: '48px',
            }}
          >
            診断をはじめる
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm" />
            </div>
          </button>
        ) : (
          <div
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-sm whitespace-nowrap"
            style={{
              background: `${item.accentColor}18`,
              color: `${item.accentColor}80`,
              fontFamily: "'M PLUS Rounded 1c', sans-serif",
              minHeight: '48px',
              cursor: 'not-allowed',
            }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-lock-line text-sm" />
            </div>
            近日公開予定
          </div>
        )}
      </div>
    </div>
  );
};

const DiagnosisGrid = () => (
  <section className="py-14 px-5" style={{ background: '#faf8ff' }}>
    <div className="max-w-2xl mx-auto">
      {/* セクションタイトル */}
      <div className="text-center mb-8">
        <p
          className="text-[10px] tracking-[0.5em] font-medium mb-2"
          style={{ color: '#a78bfa', fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          DIAGNOSIS LIST
        </p>
        <h2
          className="text-[#1a1a2e] font-bold text-xl"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          診断コンテンツ一覧
        </h2>
        <p
          className="text-[#9ca3af] text-xs mt-2"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          気になる診断を選んでスタート
        </p>
      </div>

      {/* グリッドレイアウト */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {diagnoses.map((item) => (
          <DiagnosisCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  </section>
);

export default DiagnosisGrid;
